import React, { useState, useEffect } from 'react';
import { getApi } from '../services/apiServices';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from 'react-i18next';

function CookiesPolicy() {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();

  return (
    <>

 <section className="faq terms-nd-condition">
   <div className='container'>
  <h2>{t('cookiesPolicy.title')}</h2>
  <p>
    {t('cookiesPolicy.introduction')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('cookiesPolicy.whatAreCookies.title')}</h3>
  <p>
    {t('cookiesPolicy.whatAreCookies.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('cookiesPolicy.typesOfCookies.title')}</h3>
  <ul className='terms-list'>
    <li><strong>{t('cookiesPolicy.typesOfCookies.strictlyNecessary.title')}:</strong> {t('cookiesPolicy.typesOfCookies.strictlyNecessary.description')}</li>
    <li><strong>{t('cookiesPolicy.typesOfCookies.performance.title')}:</strong> {t('cookiesPolicy.typesOfCookies.performance.description')}</li>
    <li><strong>{t('cookiesPolicy.typesOfCookies.functional.title')}:</strong> {t('cookiesPolicy.typesOfCookies.functional.description')}</li>
    <li><strong>{t('cookiesPolicy.typesOfCookies.advertising.title')}:</strong> {t('cookiesPolicy.typesOfCookies.advertising.description')}</li>
  </ul>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('cookiesPolicy.managingCookies.title')}</h3>
  <p>
    {t('cookiesPolicy.managingCookies.description')}
  </p>

  <h3 className='inner-heading' style={{ textAlign: "left" ,marin: '0', }}>{t('cookiesPolicy.changes.title')}</h3>
  <p>
    {t('cookiesPolicy.changes.description')}
  </p>
  </div>
</section>

    </>
  );
}

export default CookiesPolicy;
